import { createSlice } from "@reduxjs/toolkit";

const initialIssuesStatusesState = {};

const issuesStatusesSlice = createSlice({
  name: "issuesStatuses",
  initialState: initialIssuesStatusesState,
  reducers: {
    setIssuesStatusesData: (_state, action) =>
      action.payload.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setIssuesStatusesData } = issuesStatusesSlice.actions;

export const issuesStatuses = issuesStatusesSlice.reducer;

export default issuesStatusesSlice.reducer;
